import { ApiModel } from "./api-model";
import { Language } from "./language";
import { UserProfile } from "./user-profile";
import { Privilege } from "./privilege";

export class User extends ApiModel {
  id: number;
  login: string;
  email: string;
  isFromActiveDirectory: boolean;
  password: string;
  firstName: string;
  lastName: string;
  cleanedLastName: string;
  languages: Language[];
  currentLanguage: Language;
  profiles: UserProfile[];
  userPrivileges: Privilege[];
  privileges: Privilege[];
  resetPassword = false;

  isLocked: boolean;
  jwtToken: string;

  isEditor: boolean;
  
  get isExternal(): boolean {
    return !this.isFromActiveDirectory;
  }

  set isExternal(value: boolean) {
    this.isFromActiveDirectory = !value;
  }

  get specificRights(): boolean {
    return this.userPrivileges.length > 0;
  }

  get defaultLanguage() {
    return this.languages.find((language) => language.isDefault === true);
  }

  set defaultLanguage(language: Language) {
    this.languages.map((lang) => (lang.isDefault = false));
    this.languages.find((lang) => lang.id === language.id).isDefault = true;
  }

  get rights() {
    const rights = [];
    this.profiles.forEach((profile) => rights.concat(profile.privileges));
    return rights.concat(this.privileges);
  }

  get fullName() {
    let fullName = "";
    if (this.firstName) {
      fullName = this.firstName + " ";
    }
    if (this.lastName) {
      fullName += this.lastName;
    }
    return fullName;
  }

  constructor(data: any) {
    super(data);
    if (data.languages) {
      this.languages = data.languages.map((language) => new Language(language));
      this.currentLanguage = this.languages.find(
        (language) => language.isDefault === true
      );
    }
    if (data.privileges) {
      this.privileges = data.privileges.map(
        (privilege) => new Privilege(privilege)
      );
    } else {
      this.privileges = [];
    }
    if (data.userPrivileges) {
      this.userPrivileges = data.userPrivileges.map(
        (privilege) => new Privilege(privilege)
      );
    } else {
      this.userPrivileges = [];
    }
    if (data.profiles) {
      this.profiles = data.profiles.map((profile) => new UserProfile(profile));
    } else {
      this.profiles = [];
    }
    if (this.lastName) {
      this.cleanedLastName = this.lastName;
      if (this.lastName.includes(".external")) {
        this.cleanedLastName = this.lastName.replace(".external", "");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/user.ts